import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { CustomOutlet } from '@/components/functional/Link/CustomOutlet';
import { CustomRedirect } from '@/components/functional/Link/CustomRedirect/CustomRedirect';
import { PrevPathContextProvider } from '@/context/PrevPathContext';
import { HotlineProFirstReplyFormContextProvider } from '@/feature/hotline/professional/firstReply/context/HotlineProFirstReplyFormContext';
import { hotlineProAuthOptions } from '@/feature/hotline/professional/util/canUseHotlineUser';
import { useAuthentication } from '@/hooks/auth/useAuthentication';
/**
 * 匿名ホットライン初回相談 共通レイアウト
 */
export const HotlineProFirstReplyLayout = () => {
    // 認証周りの判定取得
    const { message: authRedirectMessage, redirectTo: authRedirectTo } = useAuthentication(hotlineProAuthOptions);
    // リダイレクト: ユーザー認証
    if (authRedirectTo) {
        return _jsx(CustomRedirect, { message: authRedirectMessage, to: authRedirectTo });
    }
    return (_jsx(PrevPathContextProvider, { children: _jsx(HotlineProFirstReplyFormContextProvider, { children: _jsx(CustomOutlet, {}) }) }));
};
